{
	"titleFirstPart": "Добре дошли в",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Общо съхранен въглерод"
}
